const image = {
  src: 'https://stgimages.christies.com/img/SaleImages/CKS-16310-07052018-1.jpg',
  alt: 'Georges Mathieu (1921-2012)',
}

const href = 'https://www.christies.com/'

export default [
  {
    image,
    primaryTitle: 'American art',
    href: href,
  },
  {
    image,
    primaryTitle: 'Books & Manuscripts',
    href: href,
  },
  {
    image,
    primaryTitle: 'Chinese Ceramics & Works of Art',
    href: href,
  },
  {
    image,
    primaryTitle: 'European Furniture & Works of Art',
    href: href,
  },
  {
    image,
    primaryTitle: 'Handbags & Accessories',
    href: href,
  },
  {
    image,
    primaryTitle: 'Impressionist & Modern Art',
    href: href,
  },
]
